import styled, { css } from 'styled-components';

type StyledPatientAvailabilityPreferenceCellProps = {
   $important: boolean;
};

export const StyledPatientAvailabilityPreferenceCell = styled.div<StyledPatientAvailabilityPreferenceCellProps>`
   display: grid;
   grid-template-columns: 1fr 24px;
   grid-template-rows: 1fr;
   grid-column-gap: 4px;
   padding: 11px 8px;
   align-items: center;
   width: 100%;
   height: 100%;

   ${(props) =>
      props.$important &&
      css`
         background-color: ${props.theme.primaryBackground};
      `}
`;
StyledPatientAvailabilityPreferenceCell.displayName = 'StyledPatientAvailabilityPreferenceCell';

export const StyledPatientAvailabilityPreferenceWholeDay = styled.div`
   grid-column: 1/2;
`;
StyledPatientAvailabilityPreferenceWholeDay.displayName = 'StyledPatientAvailabilityPreferenceWholeDay';
